import { Action } from "./Action";

export class Message {
  public message: string;
  public duration: number;
  public action?: Action;

  constructor(message: string, duration = 2000, action?: Action) {
    this.message = message;
    this.duration = duration;
    this.action = action;
  }

  public same(other: Message): boolean {
    return this.message === other.message && this.duration === other.duration && this.action === other.action;
  }
}
